<script>
  export default {
    name: 'ReviewTable',
    components: {

    },
    filters: {

    },
    mixins: [],
    props: {
      members: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {

      }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<template>
  <div class="review-table">
    <table>
      <thead>
        <tr>
          <th colspan="2">
            风险分类
          </th>
          <th>身价保障</th>
          <th>大病保障</th>
          <th>医疗保障</th>
          <th>理财保障</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="2" rowspan="2">
            风险描述
          </td>
          <td>意外，伤残保障</td>
          <td>轻症，重疾等</td>
          <td>门急诊，百万医疗等</td>
          <td>固定领取，万能账户</td>
        </tr>
        <tr>
          <td>无需担心自身收入能力减低或丧失谋生能力，是对自己和家人最大的重任</td>
          <td>专项诊疗金，解决后顾之忧，拒绝因病返贫</td>
          <td>昂贵的医疗费，社保无法报销的进口药，商业医疗险为你解决</td>
          <td>教育金，养老金等，稳健为主，利益稳定，持续成长</td>
        </tr>
        <tr>
          <td colspan="2">
            建议
          </td>
          <td>10倍年收入+负债</td>
          <td>5倍年收入+负债</td>
          <td>享受高端医疗服务</td>
          <td>养老金收入替代率60%以上；教育金提早规划，专款专用</td>
        </tr>
        <tr v-for="(item, index) in members">
          <td
            v-if="index === 0"
            class="center"
            :rowspan="members.length"
          >
            <span>家庭成员</span>
          </td>
          <td>{{ item.name }}</td>
          <template v-if="item.profitSummary">
            <td
              v-for="ps in item.profitSummary"
              :class="{'icon-center': typeof ps === 'number' && ps > 0}"
            >
              <i
                v-if="typeof ps === 'number' && ps > 0"
                class="icon-have"
              />
            </td>
          </template>
          <template v-else>
            <td v-for="i in 4" />
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
  @import 'variable.css';

  .review-table {
    thead {
      th {
        background-color: #ffb23e;
        color: #fff;
      }
      td {
        background-color: #f8f8f8;
        text-align: center;
      }
    }
    .center {
      z-index: 1;
      position: relative;
    }
  }

  .icon-center {
    text-align: center;
  }

  .icon-have {
    display: inline-block;
    width: 8px;
    height: 18px;
    border: 1px solid #ffb23e;
    border-left: none;
    border-top: none;
    transform: rotate(45deg);
  }
</style>